import styled from 'styled-components';
import { theme } from '@/styles/theme';

interface ContainerProps {
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  padding?: boolean;
}

const maxWidths = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
  full: '100%',
};

export const Container = styled.div<ContainerProps>`
  width: 100%;
  max-width: ${({ maxWidth = 'xl' }) => maxWidths[maxWidth]};
  margin: 0 auto;
  padding: ${({ padding = true }) =>
    padding ? `0 ${theme.spacing[6]}` : '0'};

  @media (max-width: ${theme.breakpoints.md}) {
    padding: ${({ padding = true }) =>
      padding ? `0 ${theme.spacing[4]}` : '0'};
  }
`;

export const Section = styled.section<{ background?: string }>`
  padding: ${theme.spacing[20]} 0;
  background: ${({ background }) => background || 'transparent'};

  @media (max-width: ${theme.breakpoints.md}) {
    padding: ${theme.spacing[12]} 0;
  }
`;

export const Grid = styled.div<{
  columns?: number;
  gap?: keyof typeof theme.spacing;
}>`
  display: grid;
  grid-template-columns: repeat(
    ${({ columns = 3 }) => columns},
    minmax(0, 1fr)
  );
  gap: ${({ gap = 6 }) => theme.spacing[gap]};

  @media (max-width: ${theme.breakpoints.lg}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: ${theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const Flex = styled.div<{
  direction?: 'row' | 'column';
  align?: string;
  justify?: string;
  gap?: keyof typeof theme.spacing;
  wrap?: boolean;
}>`
  display: flex;
  flex-direction: ${({ direction = 'row' }) => direction};
  align-items: ${({ align = 'stretch' }) => align};
  justify-content: ${({ justify = 'flex-start' }) => justify};
  gap: ${({ gap = 4 }) => theme.spacing[gap]};
  flex-wrap: ${({ wrap = false }) => (wrap ? 'wrap' : 'nowrap')};
`;
